export var ConnectableApp;
(function (ConnectableApp) {
    ConnectableApp["AREDL"] = "aredl";
    ConnectableApp["DISCORD"] = "discord";
    ConnectableApp["GITHUB"] = "github";
})(ConnectableApp || (ConnectableApp = {}));
